import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import images from 'assets/images';
import React from 'react';
import { Container } from '@mui/system';
import { practiceWithUsTimeLineObj } from 'assets/animation/portalAnimation';
import { ExpandMoreIcon } from 'shared/Icons';

const PracticeWithUs: React.FC = () => {
    const [expanded, setExpanded] = React.useState<string | false>('panel1');

    const practiceWithUsTimeLine = React.useRef(null);

    React.useEffect(() => {
        practiceWithUsTimeLineObj(practiceWithUsTimeLine);
    }, []);

    const handleExpandChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) =>
        setExpanded(newExpanded ? panel : false);

    return (
        <section className="practice-with-us" ref={practiceWithUsTimeLine}>
            <Container maxWidth="lg">
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={6}>
                        <div className="practice-mockup-block">
                            <Typography variant="h3" className="section-title">
                                Why practice with Healthreach
                            </Typography>
                            <Typography variant="body1" className="section-info">
                                Most advanced comprehensive virtual office suite and support, that makes it easier to
                                practice from anywhere in Australia.
                            </Typography>
                            <div className="practies-mockup">
                                <div className="block-layer">
                                    <div className="circle top"></div>
                                    <div className="color-layer">
                                        <div className="frame-block conference">
                                            <div className="svg-wrap">
                                                <img src={images.onlineConferenceIcon} alt="Icon" />
                                            </div>
                                            <div>
                                                <strong>In-house</strong>
                                                <span>platform</span>
                                            </div>
                                        </div>
                                        <img src={images.dashboardOne} alt="Image" className="main-mockup" />
                                        <div className="frame-block clock">
                                            <div className="svg-wrap">
                                                <img src={images.clockIcon} alt="Icon" />
                                            </div>
                                            <div>
                                                <strong>Flexible</strong>
                                                <span>timing</span>
                                            </div>
                                        </div>
                                        <div className="frame-block medication">
                                            <div className="svg-wrap">
                                                <img src={images.medicationIcon} alt="Icon" />
                                            </div>
                                            <div>
                                                <strong>Clinical Education </strong>
                                                <span>&#38; support</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="circle bottom"></div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <div className="accordion-block">
                            <Accordion
                                expanded={expanded === 'panel1'}
                                onChange={handleExpandChange('panel1')}
                                className="primary-accordion"
                            >
                                <AccordionSummary
                                    aria-controls="panel1d-content"
                                    id="panel1d-header"
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>
                                        Clinical platform designed in-house by Healthreach clinicians
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul>
                                        <li>One platform to perform all clinical functions</li>
                                        <li>No need to switch between apps or programs</li>
                                        <li>
                                            Suitable for all devices (laptops, personal computers, tablets, smartphones)
                                            including Windows, Androids, Apple
                                        </li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel2'}
                                onChange={handleExpandChange('panel2')}
                                className="primary-accordion"
                            >
                                <AccordionSummary
                                    aria-controls="panel2d-content"
                                    id="panel2d-header"
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>Total flexibility in clinical care and work-life balance</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul>
                                        <li>Practice wherever in Australia</li>
                                        <li>Practice whenever you are available</li>
                                        <li>As little or as much as you want</li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel3'}
                                onChange={handleExpandChange('panel3')}
                                className="primary-accordion"
                            >
                                <AccordionSummary
                                    aria-controls="panel3d-content"
                                    id="panel3d-header"
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>Clinical features</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul>
                                        <li>Electronic scripting</li>
                                        <li>Encrypted cloud documentation without need for paper</li>
                                        <li>Easy Medicare and gap billing </li>
                                        <li>Secure videoconferencing</li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel4'}
                                onChange={handleExpandChange('panel4')}
                                className="primary-accordion"
                            >
                                <AccordionSummary
                                    aria-controls="panel4d-content"
                                    id="panel3d-header"
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>Unique time-saving features</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul>
                                        <li>Smart History to enable quite documentation</li>
                                        <li>
                                            Smart Correspondence to enable quick conversion of your notes into
                                            correspondence, saving you time
                                        </li>
                                        <li>Allows dictation through your default operating system</li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                expanded={expanded === 'panel5'}
                                onChange={handleExpandChange('panel5')}
                                className="primary-accordion"
                            >
                                <AccordionSummary
                                    aria-controls="panel5d-content"
                                    id="panel3d-header"
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>Clinical education and support</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul>
                                        <li>
                                            Join peer review groups of your interest (eg, trauma, substance use, eating
                                            disorder etc)
                                        </li>
                                        <li>Share the experience of more senior clinicians</li>
                                        <li>Regular professional development programs (incoming)</li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

export default React.memo(PracticeWithUs);
